"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlHeroText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var theme_1 = require("../theme");
var react_1 = require("react");
var theme_2 = require("../theme");
var theme_3 = require("../theme");
exports.GlHeroText = (0, react_1.memo)(function (props) {
    var children = props.children, className = props.className;
    var _a = useStyles(), classes = _a.classes, cx = _a.cx;
    return ((0, jsx_runtime_1.jsx)(theme_1.Text, __assign({ className: cx(classes.root, className), htmlComponent: "h1", typo: "body 1" }, { children: children })));
});
var useStyles = (0, theme_2.makeStyles)({ "name": { GlHeroText: exports.GlHeroText } })(function (theme) { return ({
    "root": __assign({ "fontWeight": 700 }, (function () {
        var value = (theme.typography.rootFontSizePx / 16) *
            (function () {
                if (theme.windowInnerWidth >= theme_3.breakpointsValues.xl) {
                    return 86;
                }
                if (theme.windowInnerWidth >= 600) {
                    return 52;
                }
                return 36;
            })();
        return {
            "fontSize": value,
            "lineHeight": "".concat(value, "px"),
        };
    })()),
}); });
//# sourceMappingURL=GlHeroText.js.map